module.exports = __webpack_public_path__ + "static/media/prepaid_a07.084ec682.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/prepaid_a07.png
// module id = 735
// module chunks = 21